export default function Accessibility() {
    return <h1>This is the Accessibility page!</h1>;
}
